import backend from '@/services/backend'
// import store from '@/store'

export default {

    postDataRequest(authToken, realmName, studyName, dataRequest) {
        // console.log('postDataRequest: ' + realmName + ' / ' + studyName)
        return backend({ method: 'post', url: 'results/datarequest/'+realmName+'/'+studyName, data: dataRequest , headers: { Authorization: authToken } })
    },

}
